import { RED, INK, GREY, IVORY, DARK, LINE, paras, compact, hr, vr, dot } from "./povPages";

// Quatrième document : coordonnées exactes du PDF (canevas 960 x 540).
export function buildPovPages4(insight) {
  const b = insight.blocks;
  const pages = [];

  const eyebrow = (text) => ({ x: 44, y: 46, size: 8.5, bold: true, color: RED, upper: true, ls: "0.14em", text });
  const title = (text, w, size = 23, y = 78, lh = 1.14) => ({ x: 44, y, w, size, serif: true, bold: true, color: INK, lh, text });
  const lead = (text, y, w, size = 10.8) => ({ x: 44, y, w, size, color: INK, lh: 1.46, text });
  const itemsTitle = (text, x, y, w, size = 17) => ({ x, y, w, size, serif: true, bold: true, color: INK, lh: 1.2, text });
  const footnote = (text, w = 620) => ({ x: 44, y: 495, w, size: 6.4, color: GREY, lh: 1.4, text });
  const rule = hr(44, 916, 144);

  // 01 — couverture
  pages.push({
    bg: DARK,
    bar: RED,
    barW: 14,
    image: { src: insight.image, x: 500, y: 0, w: 460, h: 540 },
    rects: [hr(54, 372, 378, 3)],
    items: [
      { x: 54, y: 135, w: 445, size: 29, serif: true, bold: true, color: "#ffffff", lh: 1.17, text: insight.title },
      { x: 54, y: 404, w: 425, size: 14.5, bold: true, color: "#ffffff", lh: 1.3, text: insight.subtitle },
    ],
  });

  // 02 — introduction
  {
    const k = b[0];
    const [p1, p2] = paras(k.lead);
    pages.push({
      rects: [rule, { x: 495, y: 190, w: 421, h: 268, fill: IVORY }, { x: 495, y: 190, w: 5, h: 268, fill: RED }],
      items: [
        eyebrow(k.eyebrow),
        title(k.title, 910, 24),
        lead(p1, 192, 415, 10.9),
        lead(p2, 361, 415, 10.9),
        { x: 535, y: 231, w: 345, size: 24, serif: true, bold: true, color: INK, lh: 1.21, text: k.quote },
        { x: 535, y: 359, w: 350, size: 10.8, color: GREY, lh: 1.46, text: k.after },
      ],
    });
  }

  // 03 — synthèse
  {
    const k = b[1];
    const items = [eyebrow(k.eyebrow), title(k.title, 620, 25)];
    k.items.forEach((it, i) => {
      const y = 192 + 79 * i;
      const n = String(i + 1).padStart(2, "0");
      items.push({ x: 44, y: y + 1, size: 10, bold: true, color: RED, text: n, desktopOnly: true });
      items.push({ x: 102, y, w: 335, size: 14, bold: true, color: INK, lh: 1.2, text: it.label, mobileNum: n });
      items.push({ x: 460, y: y - 2, w: 435, size: 9.7, color: GREY, lh: 1.44, text: it.text });
    });
    pages.push({ rects: [rule, ...[234, 313, 392].map((y) => hr(102, 890, y, 0.7, LINE))], items });
  }

  // 04 — quatre conditions
  {
    const k = b[2];
    const items = [
      eyebrow(k.eyebrow),
      title(k.title, 730, 25),
      { x: 44, y: 148, w: 820, size: 10.3, color: GREY, lh: 1.4, text: k.lead },
      footnote(k.footnote),
    ];
    k.items.forEach((it, i) => {
      const x = i % 2 === 0 ? 44 : 490;
      const y = i < 2 ? 221 : 349;
      items.push({ x, y, w: 160, size: 15, bold: true, color: i === 0 ? RED : INK, lh: 1.2, text: it.label });
      items.push({ x: x + 165, y: y - 3, w: 237, size: 9.8, color: GREY, lh: 1.43, text: it.text });
    });
    pages.push({ rects: [hr(44, 916, 166), hr(44, 441, 299, 0.7, LINE), hr(490, 887, 299, 0.7, LINE)], items });
  }

  // 05 / 09 / 13 — ouvertures de partie
  const part = (k) => ({
    bg: "#0a0a0a",
    bar: RED,
    barW: 15,
    image: { src: k.image, x: 0, y: 0, w: 960, h: 540, overlay: true },
    rects: [hr(55, 390, 298, 0.8, "#ffffff")],
    items: [
      { x: 55, y: 129, w: 660, size: 34, serif: true, bold: true, color: "#ffffff", lh: 1.15, text: k.title },
      { x: 55, y: 325, w: 550, size: 13, color: "#ffffff", lh: 1.38, text: k.lead },
    ],
  });

  pages.push(part(b[3]));

  // 06 — trois niveaux
  {
    const k = b[4];
    const [p1, p2] = paras(k.lead);
    const items = [
      eyebrow(k.eyebrow),
      title(k.title, 760),
      lead(p1, 178, 460),
      lead(p2, 338, 465),
      itemsTitle(k.itemsTitle, 525, 194, 270),
    ];
    k.items.forEach((it, i) => {
      const y = 246 + 78 * i;
      const n = String(i + 1).padStart(2, "0");
      items.push({ x: 525, y: y + 1, size: 8, bold: true, color: RED, text: n, desktopOnly: true });
      items.push({ x: 572, y, w: 125, size: 11, bold: true, color: INK, lh: 1.2, text: it.label, mobileNum: n });
      items.push({ x: 702, y: y - 1, w: 190, size: 9, color: GREY, lh: 1.44, text: it.text });
    });
    pages.push({ rects: [rule, ...[287, 365].map((y) => hr(572, 880, y, 0.6, LINE))], items });
  }

  // 07 — rôles
  {
    const k = b[5];
    const items = [
      eyebrow(k.eyebrow),
      title(k.title, 730),
      lead(k.lead, 178, 410, 10.9),
      { x: 68, y: 323, w: 350, size: 17, serif: true, bold: true, color: INK, lh: 1.3, text: k.quote },
      footnote(k.footnote),
    ];
    k.items.forEach((it, i) => {
      const y = 198 + 53 * i;
      items.push({ x: 515, y, w: 125, size: 10.4, bold: true, color: i === 3 ? RED : INK, lh: 1.2, text: it.label });
      items.push({ x: 650, y, w: 220, size: 8.9, color: GREY, lh: 1.44, text: it.text });
    });
    pages.push({
      rects: [rule, { x: 44, y: 291, w: 400, h: 130, fill: IVORY }, ...[225, 278, 331, 384].map((y) => hr(515, 875, y, 0.6, LINE))],
      items,
    });
  }

  // 08 — gouvernance
  {
    const k = b[6];
    const [p1, p2, p3] = paras(k.lead);
    const items = [
      eyebrow(k.eyebrow),
      title(k.title, 850, 21, 77),
      lead(p1, 183, 420, 10.6),
      lead(p2, 313, 420, 10.6),
      lead(p3, 452, 415, 10.6),
      itemsTitle(k.itemsTitle, 525, 197, 310, 16.5),
    ];
    k.items.forEach((it, i) => {
      const y = 260 + 62 * i;
      items.push({ x: 525, y, w: 130, size: 10.5, bold: true, color: i === 0 ? RED : INK, lh: 1.2, text: it.label });
      items.push({ x: 660, y, w: 220, size: 9, color: GREY, lh: 1.44, text: it.text });
    });
    pages.push({ rects: [rule, ...[291, 353, 415].map((y) => hr(525, 875, y, 0.6, LINE))], items });
  }

  pages.push(part(b[7]));

  // 10 — autorisation maîtrisée
  {
    const k = b[8];
    const [p1, p2] = paras(k.lead);
    const items = [
      eyebrow(k.eyebrow),
      title(k.title, 800, 22, 77),
      lead(p1, 183, 410),
      lead(p2, 332, 410),
      itemsTitle(k.itemsTitle, 535, 215, 270, 16.5),
      footnote(k.footnote),
    ];
    k.items.forEach((it, i) => {
      const y = 258 + 40 * i;
      items.push({ x: 535, y, w: 100, size: 9.4, bold: true, color: i === 0 ? RED : INK, lh: 1.2, text: it.label });
      items.push({ x: 640, y, w: 200, size: 8.6, color: GREY, lh: 1.42, text: it.text });
    });
    pages.push({ rects: [rule, { x: 505, y: 184, w: 375, h: 272, fill: IVORY }], items });
  }

  // 11 — pouvoirs du superviseur
  {
    const k = b[9];
    const [p1, p2] = paras(k.lead);
    const rects = [rule];
    const items = [
      eyebrow(k.eyebrow),
      title(k.title, 800),
      lead(p1, 183, 455),
      lead(p2, 330, 455),
      itemsTitle(k.itemsTitle, 525, 197, 240),
      footnote(k.footnote),
    ];
    k.items.forEach((it, i) => {
      const y = 237 + 61 * i;
      rects.push(dot(530, y, 18, i === 3 ? RED : DARK));
      if (i < 3) rects.push(vr(539, y + 20, y + 54, 1.1, LINE));
      items.push({ x: 566, y: y + 5, w: 120, size: 10.5, bold: true, color: INK, lh: 1.2, text: it.label });
      items.push({ x: 680, y: y + 4, w: 200, size: 9, color: GREY, lh: 1.44, text: it.text });
    });
    pages.push({ rects, items });
  }

  // 12 — seuils d’intervention
  {
    const k = b[10];
    const [p1, p2] = paras(k.lead);
    const items = [
      eyebrow(k.eyebrow),
      title(k.title, 800, 21, 77),
      lead(p1, 183, 410),
      lead(p2, 338, 410),
      itemsTitle(k.itemsTitle, 510, 197, 290),
      footnote(k.footnote),
    ];
    k.items.forEach((it, i) => {
      const y = 240 + 49 * i;
      items.push({ x: 510, y, w: 145, size: 10.1, bold: true, color: i === 0 ? RED : INK, lh: 1.2, text: it.label });
      items.push({ x: 660, y, w: 225, size: 8.7, color: GREY, lh: 1.42, text: it.text });
    });
    pages.push({ rects: [rule, ...[265, 314, 363, 412].map((y) => hr(510, 880, y, 0.6, LINE))], items });
  }

  pages.push(part(b[11]));

  // 14 — traçabilité
  {
    const k = b[12];
    const [p1, p2] = paras(k.lead);
    const items = [
      eyebrow(k.eyebrow),
      title(k.title, 780),
      lead(p1, 183, 415),
      lead(p2, 334, 415),
      itemsTitle(k.itemsTitle, 525, 197, 310),
      footnote(k.footnote),
    ];
    k.items.forEach((it, i) => {
      const y = 241 + 49 * i;
      items.push({ x: 525, y, w: 115, size: 10.3, bold: true, color: i === 4 ? RED : INK, lh: 1.2, text: it.label });
      items.push({ x: 645, y, w: 235, size: 8.8, color: GREY, lh: 1.42, text: it.text });
    });
    pages.push({ rects: [rule, ...[266, 315, 364, 413].map((y) => hr(525, 875, y, 0.6, LINE))], items });
  }

  // 15 — discipline de réponse
  {
    const k = b[13];
    const [p1, p2, p3] = paras(k.lead);
    const items = [
      eyebrow(k.eyebrow),
      title(k.title, 745, 22, 77),
      lead(p1, 183, 415, 10.6),
      lead(p2, 319, 415, 10.6),
      lead(p3, 443, 415, 10.6),
      itemsTitle(k.itemsTitle, 525, 197, 220),
      footnote(k.footnote, 700),
    ];
    k.items.forEach((it, i) => {
      const y = 241 + 49 * i;
      const n = String(i + 1).padStart(2, "0");
      items.push({ x: 525, y: y + 2, size: 8, bold: true, color: RED, text: n, desktopOnly: true });
      items.push({ x: 570, y, w: 110, size: 10.2, bold: true, color: INK, lh: 1.2, text: it.label, mobileNum: n });
      items.push({ x: 675, y, w: 210, size: 8.8, color: GREY, lh: 1.42, text: it.text });
    });
    pages.push({ rects: [rule, ...[266, 315, 364, 413].map((y) => hr(570, 880, y, 0.6, LINE))], items });
  }

  // 16 — conclusion
  {
    const k = b[14];
    pages.push({
      bg: DARK,
      bar: RED,
      barW: 15,
      rects: [hr(54, 388, 394, 3)],
      items: [
        { x: 54, y: 76, size: 9, bold: true, color: "#d6cec6", upper: true, ls: "0.16em", text: k.eyebrow },
        { x: 54, y: 127, w: 820, size: 30, serif: true, bold: true, color: "#ffffff", lh: 1.2, text: k.title },
        { x: 54, y: 276, w: 745, size: 18, bold: true, color: "#e8e0d8", lh: 1.33, text: k.lead },
        { x: 54, y: 423, w: 730, size: 11.5, color: "#cfc7bf", lh: 1.45, text: k.after },
      ],
    });
  }

  return pages.map((p) => compact(p));
}
